<div class="atn-scenario-data-tab">
  <atn-ds-datepicker
    label="Start Date"
    [value]="startDateSg()"
    (valueChange)="startDateChangeHandler($event)"
  />
  <atn-ds-datepicker
    label="End Date"
    [value]="endDateSg()"
    (valueChange)="endDateChangeHandler($event)"
  />
</div>
